import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { ProcessElementsResource } from "core/stages-client";
import { ViewService } from "core/view.service";
import { AssociationService } from "process/associations/association.service";
import { ComplianceProcessCommentAssociationStore } from "process/compliance/associations/compliance-process-comment-association-store.logic";

@Injectable({ providedIn: "root" })
export class ComplianceProcessCommentAssociationStoreResolver
	implements Resolve<ComplianceProcessCommentAssociationStore>
{
	constructor(
		private viewService: ViewService,
		private associationService: AssociationService,
		private processElementsResource: ProcessElementsResource,
	) {}

	resolve(): ComplianceProcessCommentAssociationStore {
		return new ComplianceProcessCommentAssociationStore(
			this.viewService,
			this.associationService,
			this.processElementsResource,
		);
	}
}
